import i18n from '@/js/i18n';

const state = {
  isMenuGaucheOuvert: null,
  sectionsMenu: [],
  archiveMode: false,
};

const actions = {
  setIsMenuGaucheOuvert({ state, commit }, value) {
    commit('SET_IS_MENU_GAUCHE_OUVERT', value);
  },
  toggleMenuGauche({ state, commit }) {
    commit('SET_IS_MENU_GAUCHE_OUVERT', !state.isMenuGaucheOuvert);
  },
  addSectionMenu({ state, commit }, section) {
    commit('ADD_SECTION_MENU', { id: section['@id'], name: section.item, isOuvert: false });
  },
  setSectionMenuIsOuvert({ state, commit }, sectionId) {
    commit('SET_SECTION_MENU_IS_OUVERT', sectionId);
  },
};

const getters = {
  getIsMenuGaucheOuvert: (state) => {
    return state.isMenuGaucheOuvert;
  },
  getIsArchiveMode: (state) => {
    return state.archiveMode;
  },
  getIsSectionMenuOuvert: (state) => (id) => {
    const section = state.sectionsMenu.find((section) => {
      return section.id == id;
    });
    if (section) {
      let sectionIsOuvert = null;
      // Réciupère dans le sessionStorage le statut (Plus/Moins) des sections de menu (CED, MAS, Jeux)
      switch (section.name) {
        case i18n.t('casino.menuGauche.section.ced.libelle'):
          sectionIsOuvert = sessionStorage.getItem('toggleCEDPlusMoins') == 'true';
          break;
        case i18n.t('casino.menuGauche.section.jeux.libelle'):
          sectionIsOuvert = sessionStorage.getItem('toggleJeuxPlusMoins') == 'true';
          break;
        case i18n.t('casino.menuGauche.section.mas.libelle'):
          sectionIsOuvert = sessionStorage.getItem('toggleMASPlusMoins') == 'true';
          break;
        default:
          break;
      }
      if (sectionIsOuvert != null && section.isOuvert != sectionIsOuvert) {
        section.isOuvert = sectionIsOuvert;
      }
    }
    return section?.isOuvert;
  },
};

const mutations = {
  SET_IS_ARCHIVE_MODE(state, value) {
    state.archiveMode = value;
  },
  SET_IS_MENU_GAUCHE_OUVERT(state, value) {
    state.isMenuGaucheOuvert = value;
  },
  ADD_SECTION_MENU(state, value) {
    const section = state.sectionsMenu.find((section) => {
      return section.id == value.id;
    });
    if (!section) {
      state.sectionsMenu.push(value);
    }
  },
  SET_SECTION_MENU_IS_OUVERT(state, value) {
    const section = state.sectionsMenu.find((section) => {
      return section.id == value;
    });
    if (section) {
      section.isOuvert = !section.isOuvert;
      // Ajoute dans le sessionStorage le statut (Plus/Moins) des sections de menu (CED, MAS, Jeux)
      switch (section.name) {
        case i18n.t('casino.menuGauche.section.ced.libelle'):
          sessionStorage.setItem('toggleCEDPlusMoins', section.isOuvert);
          break;
        case i18n.t('casino.menuGauche.section.jeux.libelle'):
          sessionStorage.setItem('toggleJeuxPlusMoins', section.isOuvert);
          break;
        case i18n.t('casino.menuGauche.section.mas.libelle'):
          sessionStorage.setItem('toggleMASPlusMoins', section.isOuvert);
          break;
        default:
          break;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
